
import React, { ReactNode } from 'react';
import Header from './Header';

interface LayoutProps {
  children: ReactNode;
  showHeader?: boolean;
  title?: string;
  showBackButton?: boolean;
  className?: string;
  onBackClick?: () => void;  // Add this prop
}

const Layout: React.FC<LayoutProps> = ({ 
  children, 
  showHeader = true, 
  title,
  showBackButton = false,
  className = "",
  onBackClick  // Add this prop
}) => {
  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      {showHeader && (
        <Header 
          title={title} 
          showBackButton={showBackButton} 
          onBackClick={onBackClick}  // Pass it to Header
        />
      )}
      <main className={`flex-grow page-container pt-20 ${className}`}>
        {children}
      </main>
    </div>
  );
};

export default Layout;
